var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-statistic',{attrs:{"precision":2,"value":_vm.overviewDetails[_vm.type] || 0,"prefix":_vm.prefix,"suffix":_vm.suffix},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.$t('scope.text_298')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }